export enum DeviceModelQuality {
  SPECIFIC = "projectSpecific",
  STANDARD = "standard",
  HIGH = "highQuality"
}